var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.75C4.05 1.75 1.25 4.55 1.25 8C1.25 11.45 4.05 14.25 7.5 14.25C10.95 14.25 13.75 11.45 13.75 8C13.75 4.55 10.95 1.75 7.5 1.75ZM6.25 11.125L3.125 8L4.00625 7.11875L6.25 9.35625L10.9937 4.6125L11.875 5.5L6.25 11.125Z",
    fill: "#05176C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCheck);
export default __webpack_public_path__ + "static/media/badge-check.51caa222953291882b5556e8dc331a49.svg";
export { ForwardRef as ReactComponent };